import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from './config/wagmi';

// Pages
import HomePage from './pages/HomePage';
import WhitepaperPage from './pages/WhitepaperPage';
import NodesPage from './pages/NodesPage';
import CrowdfundPage from './pages/CrowdfundPage-EN';
import MintPage from './pages/MintPage';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Styles
import '@rainbow-me/rainbowkit/styles.css';
import './index.css';

const queryClient = new QueryClient();

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider locale="en">
          <BrowserRouter>
            <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/whitepaper" element={<WhitepaperPage />} />
                <Route path="/nodes" element={<NodesPage />} />
                <Route path="/crowdfund" element={<CrowdfundPage />} />
                <Route path="/mint" element={<MintPage />} />
              </Routes>
              <Footer />
            </div>
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
